<template id="main">
  <v-ons-bottom-toolbar class="center">
    <v-ons-button modifier="quiet"  id="btn_menu" @click="handleShowMenuList">
      <div class="toolbar_btn">
        <img src="../assets/img/history.svg" alt="">
        <span class="menu_label">{{ $store.getters.localizeLabel("Tabbar", "menu")}}</span><!--ホーム-->
      </div>
    </v-ons-button>
    
    <!--<div class="toolbar-container">-->
      <v-ons-button modifier="quiet" id="btn_survey" v-if="isSurveyMenuEnabled()">
        <a class="toolbar_btn" :href="$store.getters.QuestionnaireURL" target="_blank" style="text-decoration: none!important;">
          <img src="../assets/img/ico_survey.svg" width="24" alt="">
          <span class="menu_label">{{ $store.getters.localizeLabel("Tabbar", "questionnaire")}}</span><!--アンケート-->
        </a>
      </v-ons-button>
      <v-ons-button modifier="quiet" id="btn_call" @click="actionSheetCallVisible=true" v-if="isStaffCallMenuEnabled()">
        <div class="toolbar_btn" >
          <img src="../assets/img/call.svg" alt="">
          <span class="menu_label">{{ $store.getters.localizeLabel("Tabbar", "call")}}</span><!--呼び出し-->
        </div>
      </v-ons-button>
      <v-ons-button modifier="quiet" id="btn_history" @click="handleShowOrderHistory">
        <div class="toolbar_btn" >
          <img src="../assets/img/slip.svg" alt="">
          <span class="menu_label">{{ $store.getters.localizeLabel("Tabbar", "history")}}</span><!--注文履歴-->
        </div>
      </v-ons-button>
    <!--</div>-->

    <v-ons-action-sheet
      :visible.sync="actionSheetCallVisible"
      cancelable
      style="bottom:60px"
    >
      <v-ons-action-sheet-button icon="md-square-o" @click="handleCallStaff(1)">{{ $store.getters.localizeLabel("Tabbar", "staff_call")}}</v-ons-action-sheet-button><!--スタッフ呼び出し-->
      <v-ons-action-sheet-button icon="md-square-o" @click="handleCallStaff(11)">{{ $store.getters.localizeLabel("Tabbar", "checkout")}}</v-ons-action-sheet-button><!--お会計-->
      <v-ons-action-sheet-button icon="md-square-o" @click="actionSheetCallVisible = false">{{ $store.getters.localizeLabel("Common", "close")}}</v-ons-action-sheet-button><!--閉じる-->
    </v-ons-action-sheet>
  </v-ons-bottom-toolbar>
  
</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import setting from '../ms.config'
export default {
  name: 'msTabbar',
  /*
  props:{
    SubMenuList: { type: Array, default: [] }
  },
  */
  data () {
    return {
      actionSheetCallVisible: false,
      actionSheetVisible: false,
      callDialog1Visible: false,
      checkoutDialog1Visible: false,
      refresh:false,
      popoverVisible:false,
      popoverTarget:null,
      popoverMessage:'',
    }
  },
  mounted: function() {
    //debugger
    //this.$store.getters.SubMenuList
  },
  computed: {
    ...mapGetters([
      "localizeLabel",
      'ShopCode',
      'SubMenuName',
      'currentLangCode',
      'CheckTheSubmenuEndtime', 
      ]),
      
  },

  methods: {
    ...mapActions([
      "navigateWPPage",
      'StaffCall',
      'showMessage',
      'showErrorMessage',
      'SetHistoryPageVisible',
      'GetOrderHistory',
      'setLoadingScreenVisibility',
      'SetCurrentSubmenu',
      'SetMenuListPageVisible',
    ]),
    isSurveyMenuEnabled(){
        return setting.ENV.SURVEY_LINK_ENABLED
      },
    isStaffCallMenuEnabled(){
        return setting.ENV.STAFF_CALL_LINK_ENABLED
      },
    moveExMenu(submenu){
      //放題メニューの時間制限チェック
      //制限時間チェック
        if(this.$store.getters.CheckTheSubmenuEndtime(submenu)==false){
          this.actionSheetVisible=false
          this.showErrorMessage(submenu.GoodsName+"の商品は制限時間が過ぎているため注文できません")
          
        }else{
          this.navigateWPPage(submenu.Goods)
          .then(()=>{
            this.SetCurrentSubmenu(submenu)
            this.actionSheetVisible=false
          })
          .catch(error=>{

          })
        }
    },
    /**
     * Storeのサブメニューが反映されないので、動的にActionSheetを作成する
     */
    openSubmenuAction(){
      //this.refresh=true
      var buttons=[]
      var button_count=0
      var self=this
      this.$store.getters.SubMenuList.forEach(function(item){
        switch (self.$store.getters.currentLangCode){
          case 'ja':
            buttons.push({submenu:item ,label: item.GoodsName})
            break
          case 'en':
            buttons.push({submenu:item ,label: item.GoodsNamee})
            break
          case 'ch':
            buttons.push({submenu:item ,label: item.GoodsNamec})
            break
        }
        button_count++
      })
      buttons.push({
          label: this.$store.getters.localizeLabel("Common", "close"),
          icon: 'md-close'
      })
      this.$ons.openActionSheet({
        title: this.$store.getters.localizeLabel("Tabbar", "submenu_action_titile"),
        cancelable: true,
        buttons: buttons
      }).then(function (index) { 
        if(index==button_count){
          //cancel
        }else{
          self.moveExMenu(buttons[index].submenu)
        }
        //console.log('index: ', index) 
      });
      
    },
    label(keyName) {
      return this.localizeLabel("Tabbar", keyName);
    },
    checkSubMenuCount(){
      if($store.getters.SubMenuList.length>0){
        return true
      }else{
        return false
      }
    },
    getGoodsLangName(item){
      switch($store.getters.currentLangCode){
        case 'ja':
          return item.GoodsName
          break
        case 'en':
          return item.GoodsNamee
          break
        case 'ch':
          return item.GoodsNamc
          break
          
      }
    },
    handleCallStaff(method){
      var self=this
      this.StaffCall(method)
      .then(()=>{
        this.actionSheetCallVisible=false
        this.showMessage(self.$store.getters.localizeLabel("Tabbar", "staff_call_msg"))
      })
    },
    handleShowOrderHistory(){
      this.setLoadingScreenVisibility(true)
      this.GetOrderHistory()
        .then(()=>{ 
          this.setLoadingScreenVisibility(false)
          this.SetHistoryPageVisible(true)
        })
        .catch(()=>{
          this.setLoadingScreenVisibility(false)
        })
    },
    handleShowMenuList(){
      this.SetMenuListPageVisible(true)
    },
  },
  computed: {
    ...mapGetters(['lang'])
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import "../assets/sass/base.scss";

ons-bottom-toolbar {
  box-sizing: border-box;
  padding: 0px 10px;
  //background: black;
  background: $footer-bg;
  min-height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.button--quiet{
  padding:0!important;
  border-radius: 0;
}
.menu_label{
  margin-top: 8px;
  color: $footer-font-color;
  font-size: 10px;
//  -webkit-transform: scale(0.9);
//  -webkit-transform-origin:0 0;
  word-break: break-all;
  white-space: normal;
  line-height: 1;
  text-align: center;
}
.toolbar_btn {
  //border-right: gray 1px solid;
  box-sizing: border-box;
  width: auto;
  min-width: 50px;
  height: 60px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //border: 1px solid white;
  &.extend_menu{
    background: #E65407;
    //min-width: 100px;
    padding: 3px;
    height: 100%;
    //border-radius: 3px;
    .menu_label{
      line-height: 1.4;
    }
  }

}
.toolbar-container{
  display: flex;
  justify-content: center;
  //width: 190px;
}
.action-sheet-title{
  background: #222!important;
}
ons-action-sheet-button{
  //background: #333;
}

.action-sheet-button:last-of-type{
  //background: #222;
}

.extend_menu_block{
  height: 60px;
}
.btn_extend_menu{
  height: 100%;
  width: 100%;
  .menu_label{
    font-size: 12px;
  }
  
}
#btn_menu{
  width: 70px;
  min-width: 70px;
  max-width: 70px;

}
#btn_survey{
  width: 70px;
  min-width: 70px;
  max-width: 70px;
}
#btn_call{
  width: 70px;
  min-width: 70px;
  max-width: 70px;
}
#btn_history{
  width: 70px;
  min-width: 70px;
  max-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/msTabbar.vue